import { generatePath, matchPath } from "react-router-dom";

export const loginDestinationRoutes = {
  oauth: { root: "oauth", authorize: "authorize/:clientId" },
  gorgias: { root: "gorgias", connect: "connect" },
} as const;

const oauthAuthorizePattern =
  `/${loginDestinationRoutes.oauth.root}/${loginDestinationRoutes.oauth.authorize}` as const;

export function oauthAuthorizeUrl({ clientId }: { clientId: string }): string {
  return generatePath(oauthAuthorizePattern, {
    clientId: encodeURIComponent(clientId),
  });
}

export function isOAuthAuthorizePath(pathname: string): boolean {
  return matchPath(oauthAuthorizePattern, pathname) !== null;
}

export function gorgiasConnectUrl({ account }: { account: string }): string {
  const { root, connect } = loginDestinationRoutes.gorgias;
  return `/${root}/${connect}?${new URLSearchParams({ account })}`;
}
